import type { KeyboardEvent } from "react";
import { Copy } from "lucide-react";
import { FirestoreProductSubtitleCandidate } from "reedy-data/models";
import { Text } from "~/components/text";

export interface SubtitleListItemProps {
  subtitle: FirestoreProductSubtitleCandidate;
  index: number;
  onCopy: (subtitle: FirestoreProductSubtitleCandidate, index: number) => void;
  testId?: string;
}

export const SubtitleListItem = ({
  subtitle,
  index,
  onCopy,
  testId,
}: SubtitleListItemProps) => {
  const handleCopy = () => {
    onCopy(subtitle, index);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCopy();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className="w-full flex flex-col gap-y-2 rounded-2xl p-5 border shadow-list-item cursor-pointer bg-white group"
      onClick={handleCopy}
      onKeyDown={handleKeyDown}
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-y-2">
        <div className="flex flex-col gap-y-1">
          <Text as="span" variant="label" className="flex-1">
            &quot;{subtitle.subtitle}&quot;
          </Text>
          <Text as="span" variant="caption" className="flex-1">
            {subtitle.reasoning}
          </Text>
        </div>
        <Copy className="size-4 text-badge-cta-text cursor-pointer opacity-0 transition-opacity group-hover:opacity-100 flex-shrink-0 mt-0.5" />
      </div>
    </div>
  );
};
